import React from 'react';
import { capitalizeWords, formatAMPMDate } from '../../../../../utils/constant';

export default function ScheduleHistory({ list }) {
	const DetailRow = ({ label, value }) => (
		<div className="d-flex justify-content-start align-items-center gap-4 py-1">
			<div className="w-150 fs-4 fw-light">{label}</div>
			<div className="fs-4 fw-light">:</div>
			<div
				className="fs-4 fw-semibold"
				style={{
					color:
						value === 'paused'
							? '#FEC53D'
							: value === 'inactive'
								? '#FF0000'
								: value === 'Success'
									? '#68C230'
									: '#000',
				}}
			>
				{value}
			</div>
		</div>
	);
	return (
		<div
			className="overflow-auto"
			style={{ maxHeight: '270px' }}
		>
			{list.length > 0 ? (
				list.map((item, index) => (
					<div
						key={index}
						className="p-3 my-3 gap-4 rounded"
						style={{ background: '#F6F6F9', boxShadow: '0px 3px 8px 0px rgba(0, 0, 0, 0.05)' }}
					>
						<DetailRow
							label="Action"
							value={capitalizeWords(item.action.replaceAll('_', ' '))}
						/>
						<DetailRow
							label="Created At"
							value={item.created_at !== null ? formatAMPMDate(item.created_at) : ''}
						/>
						<DetailRow
							label="Status"
							value={item.status !== null ? capitalizeWords(item.status) : '---'}
						/>
					</div>
				))
			) : (
				<div className="d-flex text-center fs-4 fw-bold">No Scheduled History Found </div>
			)}
		</div>
	);
}
